<template>
  <Background
    class="border-b-orange border-b-4 py-10px lg:py-20px"
    :bgColor="bgColor">
    <Container>
      <div>
        <Title
          :headingTag="header.headingTag"
          :style="header.type"
          :class="textColor">
          <slot>Title</slot>
        </Title>
      </div>
    </Container>
  </Background>  
</template>

<script>
import Background from '../Atoms/Background.vue';
import Container from '../Atoms/Container.vue';
import Title from '../Atoms/Heading.vue';

import { useIsBgColor } from '../../compostables/useValidators';
import { computed } from 'vue';

export default {

  components: {
    Background,
    Container,
    Title
  },

  props: {
    bgColor: {
      type: String,
      required: false,
      default: 'navy',
      validator(value) {
          return useIsBgColor(value);
      }
    },
    header: {
      type: Object,
      required: false,
      default: {
        headingTag: 'h2',
        type: 'h2'
      }
    }
  },

  setup(props) {
    const textColor = computed(() => {
      if (props.bgColor === "navy") {
        return 'text-white'
      }
    })

    return {
      textColor
    }
  }
}
</script>

<style>

</style>